import { defaultMeetingSettings } from "src/components";
import { IMeetingSettings, useSettings } from "src/hooks";

const useMeetingSettings = (meetingGuid: string) => {
  const {
    meetingSettings: { [meetingGuid]: unsafeSettings },
    updateMeetingSettings,
  } = useSettings();

  const safeSettings: IMeetingSettings = {
    ...defaultMeetingSettings,
    ...unsafeSettings,
  };

  return {
    settings: safeSettings,
    updateSettings: (updatedSettings: Partial<IMeetingSettings>) => {
      updateMeetingSettings(meetingGuid, updatedSettings);
    },
  };
};

export { useMeetingSettings };
